var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dealer-provided-price" }, [
    _vm._v("\n    Certified Dealer Will Provide Price\n")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }